export default "__VITE_ASSET__73bf9355__"